import { useVariant } from '@calendly/feature-check-react'
import { useMemo } from 'react'

import {
  AI_CHAT_DISCOVERY_EXPERIMENT_KEY,
  AI_CHAT_DISCOVERY_FAB_APPEARANCE,
  AI_CHAT_DISCOVERY_VARIANT,
} from '../constants'
import { getAiChatDiscoveryEffectiveVariant } from '../utils'

const { BUTTON_ONLY, CONTROL } = AI_CHAT_DISCOVERY_VARIANT
const { STRING } = AI_CHAT_DISCOVERY_FAB_APPEARANCE

/**
 * AI discovery experiment: nav link, floating FAB, and FAB shape (`icon` | `string`).
 * Only use from components that mount when {@link useAiChatDiscoveryMiEligible} is true.
 */
export const useAiChatDiscoveryExperiment = () => {
  const variant = useVariant(AI_CHAT_DISCOVERY_EXPERIMENT_KEY, true)

  return useMemo(() => {
    const effectiveVariant = getAiChatDiscoveryEffectiveVariant(variant)

    const eligibleForFloating = effectiveVariant === BUTTON_ONLY

    let fabAppearance = null
    if (eligibleForFloating) {
      fabAppearance = STRING
    }

    const showsLeftNavAiLink = effectiveVariant === CONTROL

    return {
      showsFloatingLauncher: Boolean(eligibleForFloating && fabAppearance),
      showsLeftNavAiLink,
      fabAppearance,
    }
  }, [variant])
}
